import { DelegateMapEntry } from 'containers/Base/ActionDelegate';
import { Environment } from 'data/terra/Environment';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import Terra from 'services/apis/terra/Terra';
import { RootState } from 'store/reducer';
import { CommonState } from '../reducer';

export const FETCH_ENVIRONMENTS = 'FETCH_ENVIRONMENTS';

export interface FetchEnvironmentsAction {
  type: typeof FETCH_ENVIRONMENTS;
  environments: Environment[];
  error?: string;
}

export const fetchEnvironments = (): ThunkAction<
  void,
  RootState,
  unknown,
  Action<string>
> => async dispatch => {
  const result = await Terra.environment.fetchEnvironments();
  if (result.isSuccess()) {
    dispatch({
      type: FETCH_ENVIRONMENTS,
      environments: result.get()!.data,
    } as FetchEnvironmentsAction);
  } else {
    dispatch({
      type: FETCH_ENVIRONMENTS,
      environments: [],
      error: result.exception().message,
    } as FetchEnvironmentsAction);
  }

  return result;
};

export const fetchEnvironmentsDelegate: DelegateMapEntry<
  FetchEnvironmentsAction,
  CommonState
> = {
  [FETCH_ENVIRONMENTS]: (
    state: CommonState,
    action: FetchEnvironmentsAction
  ): CommonState => {
    return {
      ...state,
      environments: action.environments,
      environmentError: action.error,
    };
  },
};
